import React, { useState, useEffect, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import FinalEmployeeList from './listing/FinalEmployeeList'
import Request from './request/Request'
import AuthContext from 'context/AuthContext'
import { apiGet } from 'utils/apiFetch'
import apiPath from 'utils/apiPath'
 
const tabBtnClass =
  'inline-block py-3 px-8 text-md xl:text-lg font-semibold border-b-2'
const tabActiveClass = 'border-blue-600 text-blue-600'
const tabBorderNoneClass = 'border-transparent'
const TAB_LISTING = 'listing'
const TAB_REQUEST = 'request'
 
const EmployeeRequest = () => {
  const { t } = useTranslation()
  const { updatePageName } = useContext(AuthContext)
 
  const [defaultTab, setDefaultTab] = useState('listing')
 
  useEffect(() => {
    const fetchStatusAndUpdateHeader = async () => {
      try {
        const path = apiPath.hrCompletionStatus
        const result = await apiGet(path, {})
       
        if (result.data.success) {
          const isComplete = result.data.results.isComplete;
         
          if (!isComplete) {
            updatePageName(
              <span>
                Job Requests Management
              </span>
            )
          } else {
            updatePageName(<span>Job Requests Management</span>)
          }
        }
      } catch (error) {
        console.log('Error fetching HR status:', error)
      }
    }
   
    fetchStatusAndUpdateHeader()
   
  // THE FIX: Empty array [] means this runs ONLY ONCE when the page loads
  }, [])
 
  const handleTabClick = (action, e) => {
    setDefaultTab(action)
  }
 
  const getContent = () => {
    if (defaultTab === TAB_LISTING) {
      return <FinalEmployeeList />
    } else if (defaultTab === TAB_REQUEST) {
      return <Request />
    }
    return null
  }
 
  return (
    <>
      <div className='py-5 px-9'>
        <div className='py-3 my-2'>
          <ul className='border-b flex'>
            <li className='mr-0 xl:mr-5'>
              <button
                onClick={handleTabClick.bind(this, TAB_LISTING)}
                className={classNames({
                  [tabBtnClass]: true,
                  [tabActiveClass]: defaultTab === TAB_LISTING,
                  [tabBorderNoneClass]: defaultTab !== TAB_LISTING
                })}
              >
                {t('LISTING')}
              </button>
            </li>
            <li className='mx-0 xl:mx-5'>
              <button
                onClick={handleTabClick.bind(this, TAB_REQUEST)}
                className={classNames({
                  [tabBtnClass]: true,
                  [tabActiveClass]: defaultTab === TAB_REQUEST,
                  [tabBorderNoneClass]: defaultTab !== TAB_REQUEST
                })}
              >
                {t('REQUEST')}
              </button>
            </li>
          </ul>
        </div>
 
        {getContent()}
      </div>
    </>
  )
}
 
export default EmployeeRequest





// import React, { useState, useEffect, useContext } from 'react'
// import { useTranslation } from 'react-i18next'
// import classNames from 'classnames'
// import FinalEmployeeList from './listing/FinalEmployeeList'
// import Request from './request/Request'
// import AuthContext from 'context/AuthContext'
// import { apiGet } from 'utils/apiFetch'
// import apiPath from 'utils/apiPath'

// const tabBtnClass =
//   'inline-block py-3 px-8 text-md xl:text-lg font-semibold border-b-2'
// const tabActiveClass = 'border-blue-600 text-blue-600'
// const tabBorderNoneClass = 'border-transparent'
// const TAB_LISTING = 'listing'
// const TAB_REQUEST = 'request'

// const EmployeeRequest = () => {
//   const { t } = useTranslation()
//   const { updatePageName } = useContext(AuthContext)

//   const [defaultTab, setDefaultTab] = useState('listing')

//   useEffect(() => {
//     const fetchStatusAndUpdateHeader = async () => {
//       try {
//         const path = apiPath.hrCompletionStatus 
//         const result = await apiGet(path, {})
        
//         if (result.data.success) {
//           const isComplete = result.data.results.isComplete;
          
//           if (!isComplete) {
//             updatePageName(
//               <span>
//                 Job Requests Management
//               </span>
//             )
//           } else {
//             updatePageName(<span>Job Requests Management</span>)
//           }
//         }
//       } catch (error) {
//         console.log('Error fetching HR status:', error)
//       }
//     }
    
//     fetchStatusAndUpdateHeader()
    
//   // THE FIX: Empty array [] means this runs ONLY ONCE when the page loads
//   }, []) 

//   const handleTabClick = (action, e) => {
//     setDefaultTab(action)
//   }

//   const getContent = () => {
//     if (defaultTab === TAB_LISTING) {
//       return <FinalEmployeeList />
//     } else if (defaultTab === TAB_REQUEST) {
//       return <Request />
//     }
//     return null
//   }

//   return (
//     <>
//       <div className='py-5 px-9'>
//         <div className='py-3 my-2'>
//           <ul className='border-b flex'>
//             <li className='mr-0 xl:mr-5'>
//               <button
//                 onClick={handleTabClick.bind(this, TAB_LISTING)}
//                 className={classNames({
//                   [tabBtnClass]: true,
//                   [tabActiveClass]: defaultTab === TAB_LISTING,
//                   [tabBorderNoneClass]: defaultTab !== TAB_LISTING
//                 })}
//               >
//                 {t('LISTING')}
//               </button>
//             </li>
//             <li className='mx-0 xl:mx-5'>
//               <button
//                 onClick={handleTabClick.bind(this, TAB_REQUEST)}
//                 className={classNames({
//                   [tabBtnClass]: true,
//                   [tabActiveClass]: defaultTab === TAB_REQUEST,
//                   [tabBorderNoneClass]: defaultTab !== TAB_REQUEST
//                 })}
//               >
//                 {t('REQUEST')}
//               </button>
//             </li>
//           </ul>
//         </div>

//         {getContent()}
//       </div>
//     </>
//   )
// }

// export default EmployeeRequest